'use strict';

export var formatPrice = function formatPrice(value, locale) {
  if (value && locale) {
    return value.toLocaleString(locale);
  }
  return Number(value).toString();
};
export var getFormattedAmount = function getFormattedAmount(value, currency, locale) {
  var formattedAmount = formatPrice(value, locale);
  if (currency && currency.pre) {
    return "".concat(currency.pre, " ").concat(formattedAmount);
  } else if (currency && currency.post) {
    return "".concat(formattedAmount, " ").concat(currency.post);
  }
  return formattedAmount;
};